import { Tab } from "@blueprintjs/core";
import { useApiEffect } from "nsitools-react";
import * as React from "react";
import { useHistory, useParams } from "react-router";

import { TypeCoursDetailPage } from "..";
import { TypeCoursApi } from "../../../../../api";
import { ERoutes } from "../../../../../AppRouter";
import { BackButton, PageBase, ProtectedTabs } from "../../../../../components";
import { useApiService, useTl } from "../../../../../hooks";
import { ETLCodes } from "../../../../../locales";

interface ITypeCoursItemPageProps {}

export const TypeCoursItemPage: React.FunctionComponent<ITypeCoursItemPageProps> = () => {
  const { t } = useTl();
  const { id, tab, state = "edit" } = useParams<{ id: string; tab: string; state: string }>();
  const history = useHistory();

  const typeCoursApi = useApiService(TypeCoursApi);
  const [displayName] = useApiEffect(() => typeCoursApi.typeCoursGetDisplayName({ id: id }), [id]);

  return (
    <PageBase
      breadCrumbs={[
        { text: t(ETLCodes.TypesCours), route: ERoutes.typeCours },
        { text: id === "0" ? t(ETLCodes.New) : displayName }
      ]}
    >
      <ProtectedTabs
        id="TabsTypeCours"
        onChange={newTabId => history.push(`${ERoutes.typeCours}/${id}/${newTabId}`)}
        selectedTabId={tab}
        renderActiveTabPanelOnly
      >
        <BackButton backRoute={ERoutes.typeCours}></BackButton>
        <Tab
          id="detail"
          title={t(ETLCodes.Detail)}
          panel={<TypeCoursDetailPage codeTypeCours={id} editMode={state === "edit"} />}
        />
      </ProtectedTabs>
    </PageBase>
  );
};
